<template>
  <el-form style="margin: 0 30px" ref="form" :model="form" label-position="left" label-width="120">
    <el-form-item label="姓名">
      {{ form.name }}
    </el-form-item>
    <el-form-item label="公司">
      {{ form.company }}
    </el-form-item>
    <el-form-item label="手机">
      {{ form.mobile }}
    </el-form-item>
    <el-form-item label="垂询事宜">
      {{ form.content }}
    </el-form-item>
    <el-form-item label="备注" prop="memo">
      <el-input type="textarea" :rows="5" v-model="form.memo"></el-input>
    </el-form-item>
  </el-form>

  <el-divider></el-divider>

  <div class="el-dialog__footer">
    <el-button type="primary" @click="btnSubmitClick">确 定</el-button>
    <el-button @click="btnCancelClick">取 消</el-button>
  </div>
</template>

<script lang="ts">
import { IElForm } from '@/types/element';
import { IContact } from '@/types/models';
import { defineComponent, PropType } from 'vue';

interface IForm {
  name: string;
  company: string;
  mobile: string;
  content: string;
  memo: string;
}

interface IState {
  form: IForm;
}

export default defineComponent({
  props: {
    contact: {
      type: Object as PropType<IContact>,
      required: true,
    },
  },
  emits: ['cancel', 'submit'],
  data() {
    return {
      form: {
        name: this.contact.name,
        company: this.contact.company,
        mobile: this.contact.mobile,
        content: this.contact.content,
        memo: this.contact.memo,
      },
    } as IState;
  },
  methods: {
    btnCancelClick() {
      this.$emit('cancel');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form.memo);
        }
      });
    },
  },
  watch: {
    contact(value: IContact) {
      this.form.name = value.name;
      this.form.company = value.company;
      this.form.mobile = value.mobile;
      this.form.content = value.content;
      this.form.memo = value.memo;
    },
  },
});
</script>
